import styled from "@emotion/styled"
import { spacingStaticXs, spacingStaticSm, spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { SkeletonRadioButton } from "./SkeletonRadioButton"
import { SkeletonText } from "./SkeletonText"

interface SkeletonRadioGroupProps {
	className?: string
	count?: number
	horizontal?: boolean
	/** main description after label */
	withDescription?: boolean
	/** description for each radio button */
	withDescriptions?: boolean
	withLabel?: boolean
}

export const SkeletonRadioGroup = ({
	className,
	count = 4,
	horizontal,
	withDescription,
	withDescriptions,
	withLabel,
}: SkeletonRadioGroupProps) => (
	<Wrapper className={className}>
		{withLabel &&
			(withDescription ? (
				<LabelDescriptionWrapper>
					<SkeletonText $width="25%" />
					{withDescription && <DescriptionSkeletonText size="xs" $width="50%" />}
				</LabelDescriptionWrapper>
			) : (
				<SkeletonText $width="25%" />
			))}
		<Layout $horizontal={horizontal}>
			{Array.from({ length: count }, (_, i) =>
				withDescriptions ? (
					<RadioDescriptionWrapper key={i}>
						<SkeletonRadioButton />
						{withDescriptions && <SkeletonText size="xs" $width="50%" />}
					</RadioDescriptionWrapper>
				) : (
					<SkeletonRadioButton key={i} />
				),
			)}
		</Layout>
	</Wrapper>
)

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticSm};
`

const LabelDescriptionWrapper = styled(Wrapper)`
	gap: ${spacingStaticXs};
`

const DescriptionSkeletonText = styled(SkeletonText)`
	margin: -2px 0;
`

const Layout = styled(Wrapper)<{ $horizontal?: boolean }>`
	${({ $horizontal }) =>
		$horizontal &&
		`
		flex-direction: row;
		gap: ${spacingStaticMd};
	`};
`

const RadioDescriptionWrapper = styled(Wrapper)`
	gap: ${spacingStaticXs};
`
